<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><em>Mountain of Light</em></h2>
<p class="para">I do not write this to complain; I have written the plain truth. I do not write to praise myself but to set down exactly what happened. In this history I have been determined to write truthfully about everything. As a consequence I have set down all that is good or bad I have seen of father, kinsman or stranger. Reader, pardon this . . .</p>
<p class="right-para"><em>Diary of Babur, Founder of the Moghul Empire</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter03.vue?1b1ed741